import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  X,
  User,
  Mail,
  Phone,
  MapPin,
  Calendar,
  Briefcase,
  Star,
  Edit,
  FileText,
  MessageSquare,
  Clock,
  Award,
  DollarSign,
  Settings,
  ChevronDown,
  Eye,
  Download,
  Plus,
  CheckCircle2,
  XCircle,
  AlertCircle,
  Building,
  Globe,
  Users,
  Target,
  TrendingUp,
  Activity
} from "lucide-react";
import { AddDocumentModal } from "../../components/reusableComponents/AddDocumentModal";
import { AddInterviewModal } from "../../components/reusableComponents/AddInterviewModal";
import { AddCommentModal } from "../../components/reusableComponents/AddCommentModal";
import { AddOpportunityModal } from "../../components/reusableComponents/AddOpportunityModal";
import { AddContractModal } from "../../components/reusableComponents/AddContractModal";
import { AddPayslipModal } from "../../components/reusableComponents/AddPayslipModal";
import { ActivateCandidateModal } from "../../components/reusableComponents/ActivateCandidateModal";
import { AdvancePaymentModal } from "../../components/reusableComponents/AdvancePaymentModal";
import { ReferenceCheckModal } from "../../components/reusableComponents/ReferenceCheckModal";
import { SendToFreelanceModal } from "../../components/reusableComponents/SendToFreelanceModal";
import { SickLeaveModal } from "../../components/reusableComponents/SickLeaveModal";
import { AddAtdModal } from "../../components/reusableComponents/AddAtdModal";
import { PlacementContractModal } from "../../components/reusableComponents/PlacementContractModal";
import { EditProfileModal } from "../../components/reusableComponents/EditProfileModal";
import { AddRatingModal } from "../../components/reusableComponents/AddratingModal";
import DocumentSection from "./DocumentSection";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../axios/AxiosInstance";
import { countries } from "../../utils/countries";
import AvailableTable from "./AvailableTable";
import CandidateComment from "./CandidateComment";
import CandidatContract from "./CandidateContract";
import InterviewsSection from "./InterviewsSection";
import OpportunitiesSection from "./OpportunitiesSection";
import PaymentsSection from "./PaymentsSection";
import RatingsSection from "./RatingsSection";

export const CandidateModal = ({
  isOpen,
  onClose,
  candidate,
  candidates,
  setCandidates,
}) => {
  // Tabs state
  const [activeTab, setActiveTab] = useState("profile");
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [entretien, setEntretien] = useState([]);
  const [activeCandidate, setActiveCandidate] = useState({ ...candidate });

  // Modal states
  const [isAddDocumentModalOpen, setIsAddDocumentModalOpen] = useState(false);
  const [isAddInterviewModalOpen, setIsAddInterviewModalOpen] = useState(false);
  const [isAddCommentModalOpen, setIsAddCommentModalOpen] = useState(false);
  const [isAddOpportunityModalOpen, setIsAddOpportunityModalOpen] =
    useState(false);
  const [isAddRatingModalOpen, setIsAddRatingModalOpen] = useState(false);
  const [isAddContractModalOpen, setIsAddContractModalOpen] = useState(false);
  const [isAddPayslipModalOpen, setIsAddPayslipModalOpen] = useState(false);
  const [isActivateModalOpen, setIsActivateModalOpen] = useState(false);
  const [isAdvancePaymentModalOpen, setIsAdvancePaymentModalOpen] =
    useState(false);
  const [isReferenceCheckModalOpen, setIsReferenceCheckModalOpen] =
    useState(false);
  // Données liées aux acomptes
  const [advancePayments, setAdvancePayments] = useState([]);
  const [formData, setFormData] = useState({ ...candidate });
  const [isSendToFreelanceModalOpen, setIsSendToFreelanceModalOpen] =
    useState(false);
  const [isSickLeaveModalOpen, setIsSickLeaveModalOpen] = useState(false);
  const [isAddAtdModalOpen, setIsAddAtdModalOpen] = useState(false);
  const [isPlacementContractModalOpen, setIsPlacementContractModalOpen] =
    useState(false);
  const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState(false);

  // Action select state
  const [selectedAction, setSelectedAction] = useState("");
  const [showNet, setShowNet] = useState(false); // Etat pour basculer entre brut et net

  useEffect(() => {
    getEntretien();
  }, []);

  // Fonction pour obtenir l'icône de statut
  const getStatusIcon = (status) => {
    switch (status) {
      case 'Disponible':
        return <CheckCircle2 className="w-4 h-4 text-green-600" />;
      case 'En mission':
        return <Clock className="w-4 h-4 text-orange-500" />;
      case 'Indisponible':
        return <XCircle className="w-4 h-4 text-red-500" />;
      default:
        return <AlertCircle className="w-4 h-4 text-gray-500" />;
    }
  };

  // Fonction pour obtenir la couleur de statut
  const getStatusColor = (status) => {
    switch (status) {
      case 'Disponible':
        return 'text-green-600 bg-green-50 border-green-200';
      case 'En mission':
        return 'text-orange-600 bg-orange-50 border-orange-200';
      case 'Indisponible':
        return 'text-red-600 bg-red-50 border-red-200';
      default:
        return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };

  // Formatage de l'expérience
  const formatExperience = (years) => {
    if (years === 0) return "Débutant";
    if (years === 1) return "1 an d'expérience";
    return `${years} ans d'expérience`;
  };

  // Formatage des montants avec gestion des erreurs
  const formatAmount = (amount, decimals = 0) => {
    if (!amount || amount === null || amount === undefined) {
      return "Non renseigné";
    }

    const numAmount = parseFloat(amount);
    if (isNaN(numAmount)) {
      return "Non renseigné";
    }

    return decimals > 0 ? numAmount.toFixed(decimals) : numAmount.toLocaleString();
  };

  const getEntretien = () => {
    axios
      .get(`entretien/${candidate._id}`)
      .then((res) => setEntretien(res.data))
      .catch((e) => {
        console.log(e);
      });
  };

  const handleToggleSalary = () => {
    setShowNet(!showNet); // Inverse la valeur de showNet
  };

  // Formatage de la date au format français
  const formatDate = (dateString) => {
    if (!dateString) return "Non renseigné";

    const date = new Date(dateString);

    // Vérifier si la date est valide
    if (isNaN(date.getTime())) {
      return "Date invalide";
    }

    return new Intl.DateTimeFormat("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  };

  const updateCandidate = async () => {
    setLoadingUpdate(true);
    try {
      // Envoi de la requête de mise à jour au serveur
      const { data } = await axios.post(
        `tempworker-candidate/${candidate._id}/update`,
        formData,
      );
      // Affichage de la notification de succès
      toast.success("Modifications enregistrées !");
      // Mise à jour des candidats dans l'état
      setCandidates((prevCandidates) => {
        return prevCandidates.map((c) =>
          c._id === candidate._id ? { ...c, ...data } : c,
        );
      });
      setActiveCandidate(data);
    } catch (error) {
      // Gestion des erreurs
      console.error("Error updating candidate: ", error);
      toast.error("Une erreur s'est produite !");
    }
    setLoadingUpdate(false);
  };

  const formatDateForInput = (date) => {
    if (!date) return "";

    const newDate = new Date(date);

    // Vérifier si la date est valide
    if (isNaN(newDate.getTime())) {
      return "";
    }

    const year = newDate.getFullYear();
    const month = (newDate.getMonth() + 1).toString().padStart(2, "0");
    const day = newDate.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const setYearlySalary = (value) => {
    const parsed = parseFloat(value);

    if (value === "" || isNaN(parsed)) {
      setFormData((prevData) => ({
        ...prevData,
        yearlySalaryExpectations: "",
        monthlySalaryExpectations: "",
        dailySalaryExpectations: "",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        yearlySalaryExpectations: parsed,
        monthlySalaryExpectations: parsed / 12,
        dailySalaryExpectations: parsed / 12 / 151.67, // ex: 21.67 jours ouvrés/mois
      }));
    }
  };

  /*   const setMonthlySalary = (value) => {
    if (value === '') {
      setYearlySal('')
      setMonthlySal('')
      setDailySal('')
    } else {
      setYearlySal((parseFloat(value) * 12).toFixed(2))
      setMonthlySal(value)
      setDailySal((parseFloat(value) / 151.67).toFixed(2))
    }
  }

  const setDailySalary = (value) => {
    if (value === '') {
      setYearlySal('')
      setMonthlySal('')
      setDailySal('')
    } else {
      setYearlySal((parseFloat(value) * 12 * 151.67).toFixed(2))
      setMonthlySal((parseFloat(value) * 151.67).toFixed(2))
      setDailySal(value)
    }
  } */

  // Définition des onglets
  const tabs = [
    { id: "profile", label: "Profil", icon: User },
    { id: "documents", label: "Documents", icon: FileText },
    { id: "availability", label: "Disponibilité", icon: Clock },
    { id: "interviews", label: "Entretiens", icon: Calendar },
    { id: "comments", label: "Commentaires", icon: MessageSquare },
    { id: "opportunities", label: "Pressenti", icon: Target },
    { id: "contracts", label: "Contrats", icon: Briefcase },
    { id: "payments", label: "Paie", icon: DollarSign },
    { id: "ratings", label: "Notations", icon: Star },
  ];

  if (!candidate) {
    return null;
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="bg-white rounded-2xl shadow-2xl w-full max-w-7xl h-[90vh] flex flex-col overflow-hidden"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-8 py-6 text-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="relative">
                    {candidate.image ? (
                      <img
                        src={`data:image/jpeg;base64,${candidate.image}`}
                        alt={`${candidate.firstname} ${candidate.lastname}`}
                        className="w-16 h-16 rounded-full object-cover border-3 border-white shadow-lg"
                      />
                    ) : (
                      <div className="w-16 h-16 rounded-full bg-white bg-opacity-20 flex items-center justify-center text-white text-xl font-bold border-3 border-white">
                        {activeCandidate.firstname?.charAt(0)}{activeCandidate.lastname?.charAt(0)}
                      </div>
                    )}
                    <div className={`absolute -bottom-1 -right-1 w-5 h-5 rounded-full border-2 border-white ${
                      candidate.status === 'Disponible' ? 'bg-green-500' :
                      candidate.status === 'En mission' ? 'bg-orange-500' : 'bg-red-500'
                    }`}></div>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold capitalize">
                      {activeCandidate.firstname} {activeCandidate.lastname}
                    </h2>
                    <p className="text-blue-100 text-lg">
                      {candidate.jobTitle || 'Candidat'}
                    </p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  {/* Menu d'actions */}
                  <motion.div className="relative">
                    <motion.select
                      className="px-4 py-2 bg-white bg-opacity-20 border border-white border-opacity-30 rounded-xl text-white text-sm font-medium focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 backdrop-blur-sm"
                      value={selectedAction}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedAction(value);
                        switch (value) {
                          case "activer":
                            setIsActivateModalOpen(true);
                            break;
                          case "acompte":
                            setIsAdvancePaymentModalOpen(true);
                            break;
                          case "controle-reference":
                            setIsReferenceCheckModalOpen(true);
                            break;
                          case "entretien":
                            setIsAddInterviewModalOpen(true);
                            break;
                          case "freelance":
                            setIsSendToFreelanceModalOpen(true);
                            break;
                          case "arret":
                            setIsSickLeaveModalOpen(true);
                            break;
                          case "edit":
                            setIsEditProfileModalOpen(true);
                            break;
                        }
                      }}
                      whileFocus={{ scale: 1.02 }}
                    >
                      <option value="">Actions rapides</option>
                      <option value="edit">Modifier le profil</option>
                      <option value="activer">Activer le compte</option>
                      <option value="acompte">Faire un acompte</option>
                      <option value="controle-reference">Contrôle de référence</option>
                      <option value="entretien">Créer un RDV entretien</option>
                      <option value="freelance">Envoyer à freelance</option>
                      <option value="arret">Ajouter un arrêt maladie</option>
                    </motion.select>
                  </motion.div>

                  {/* Bouton fermer */}
                  <motion.button
                    onClick={onClose}
                    className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors duration-200"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <X className="w-6 h-6" />
                  </motion.button>
                </div>
              </div>
            </div>

            {/* Navigation par onglets */}
            <div className="bg-slate-50 border-b border-slate-200">
              <div className="px-8">
                <div className="flex overflow-x-auto scrollbar-hide">
                  {tabs.map((tab) => {
                    const IconComponent = tab.icon;
                    return (
                      <motion.button
                        key={tab.id}
                        className={`flex items-center space-x-2 px-6 py-4 text-sm font-medium border-b-2 transition-all duration-200 whitespace-nowrap ${
                          activeTab === tab.id
                            ? "text-blue-600 border-blue-600 bg-white"
                            : "text-slate-600 border-transparent hover:text-slate-900 hover:border-slate-300"
                        }`}
                        onClick={() => setActiveTab(tab.id)}
                        whileHover={{ y: -1 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <IconComponent className="w-4 h-4" />
                        <span>{tab.label}</span>
                      </motion.button>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Contenu des onglets */}
            <div className="flex-1 overflow-y-auto">
              <div className="p-8">

                <AnimatePresence mode="wait">
                  {activeTab === "profile" && (
                    <motion.div
                      key="profile"
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                      transition={{ duration: 0.3 }}
                      className="space-y-8"
                    >
                      {/* Informations principales */}
                      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                        {/* Informations personnelles */}
                        <motion.div
                          className="lg:col-span-2 bg-white rounded-xl shadow-sm border border-slate-200 p-6"
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.4, delay: 0.1 }}
                        >
                          <div className="flex items-center space-x-3 mb-6">
                            <div className="p-2 bg-blue-100 rounded-lg">
                              <User className="w-5 h-5 text-blue-600" />
                            </div>
                            <h3 className="text-xl font-semibold text-slate-900">Informations personnelles</h3>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="space-y-4">
                              <div>
                                <label className="text-sm font-medium text-slate-700">Prénom</label>
                                <p className="text-slate-900 capitalize">{candidate.firstname}</p>
                              </div>
                              <div>
                                <label className="text-sm font-medium text-slate-700">Nom</label>
                                <p className="text-slate-900 capitalize">{candidate.lastname}</p>
                              </div>
                              <div>
                                <label className="text-sm font-medium text-slate-700">Email</label>
                                <div className="flex items-center space-x-2">
                                  <Mail className="w-4 h-4 text-slate-400" />
                                  <p className="text-slate-900">{candidate.email}</p>
                                </div>
                              </div>
                              <div>
                                <label className="text-sm font-medium text-slate-700">Téléphone</label>
                                <div className="flex items-center space-x-2">
                                  <Phone className="w-4 h-4 text-slate-400" />
                                  <p className="text-slate-900">{candidate.phone}</p>
                                </div>
                              </div>
                            </div>

                            <div className="space-y-4">
                              <div>
                                <label className="text-sm font-medium text-slate-700">Date de naissance</label>
                                <div className="flex items-center space-x-2">
                                  <Calendar className="w-4 h-4 text-slate-400" />
                                  <p className="text-slate-900">{formatDate(candidate.birthDate)}</p>
                                </div>
                              </div>
                              <div>
                                <label className="text-sm font-medium text-slate-700">Nationalité</label>
                                <div className="flex items-center space-x-2">
                                  <Globe className="w-4 h-4 text-slate-400" />
                                  <p className="text-slate-900">{candidate.nationality}</p>
                                </div>
                              </div>
                              <div>
                                <label className="text-sm font-medium text-slate-700">Adresse</label>
                                <div className="flex items-center space-x-2">
                                  <MapPin className="w-4 h-4 text-slate-400" />
                                  <p className="text-slate-900">{candidate.address}</p>
                                </div>
                              </div>
                              <div>
                                <label className="text-sm font-medium text-slate-700">Statut</label>
                                <div className={`inline-flex items-center space-x-1 px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(candidate.status)}`}>
                                  {getStatusIcon(candidate.status)}
                                  <span>{candidate.status}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </motion.div>

                        {/* Statut et actions rapides */}
                        <motion.div
                          className="space-y-6"
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.4, delay: 0.2 }}
                        >
                          {/* Carte de statut */}
                          <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
                            <div className="flex items-center space-x-3 mb-4">
                              <div className="p-2 bg-green-100 rounded-lg">
                                <Activity className="w-5 h-5 text-green-600" />
                              </div>
                              <h3 className="text-lg font-semibold text-slate-900">Statut actuel</h3>
                            </div>
                            <div className={`p-4 rounded-lg border-2 ${getStatusColor(candidate.status)}`}>
                              <div className="flex items-center space-x-2 mb-2">
                                {getStatusIcon(candidate.status)}
                                <span className="font-medium">{candidate.status}</span>
                              </div>
                              <p className="text-sm opacity-75">
                                {candidate.status === 'Disponible' && 'Prêt pour de nouvelles missions'}
                                {candidate.status === 'En mission' && 'Actuellement en mission'}
                                {candidate.status === 'Indisponible' && 'Non disponible temporairement'}
                              </p>
                            </div>
                          </div>

                          {/* Actions rapides */}
                          <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
                            <div className="flex items-center space-x-3 mb-4">
                              <div className="p-2 bg-purple-100 rounded-lg">
                                <Settings className="w-5 h-5 text-purple-600" />
                              </div>
                              <h3 className="text-lg font-semibold text-slate-900">Actions rapides</h3>
                            </div>
                            <div className="space-y-3">
                              <motion.button
                                onClick={() => setIsEditProfileModalOpen(true)}
                                className="w-full flex items-center space-x-3 p-3 text-left hover:bg-slate-50 rounded-lg transition-colors duration-200"
                                whileHover={{ x: 4 }}
                              >
                                <Edit className="w-4 h-4 text-slate-400" />
                                <span className="text-sm text-slate-700">Modifier le profil</span>
                              </motion.button>
                              <motion.button
                                onClick={() => setIsAddInterviewModalOpen(true)}
                                className="w-full flex items-center space-x-3 p-3 text-left hover:bg-slate-50 rounded-lg transition-colors duration-200"
                                whileHover={{ x: 4 }}
                              >
                                <Calendar className="w-4 h-4 text-slate-400" />
                                <span className="text-sm text-slate-700">Planifier entretien</span>
                              </motion.button>
                              <motion.button
                                onClick={() => setIsAddCommentModalOpen(true)}
                                className="w-full flex items-center space-x-3 p-3 text-left hover:bg-slate-50 rounded-lg transition-colors duration-200"
                                whileHover={{ x: 4 }}
                              >
                                <MessageSquare className="w-4 h-4 text-slate-400" />
                                <span className="text-sm text-slate-700">Ajouter commentaire</span>
                              </motion.button>
                            </div>
                          </div>
                        </motion.div>
                      </div>
                      {/* Compétences et expérience */}
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                        {/* Compétences */}
                        {candidate.qualifications && candidate.qualifications.length > 0 && (
                          <motion.div
                            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4, delay: 0.3 }}
                          >
                            <div className="flex items-center space-x-3 mb-6">
                              <div className="p-2 bg-green-100 rounded-lg">
                                <Award className="w-5 h-5 text-green-600" />
                              </div>
                              <h3 className="text-xl font-semibold text-slate-900">Compétences</h3>
                            </div>
                            <div className="flex flex-wrap gap-2">
                              {candidate.qualifications.map((skill, index) => (
                                <motion.span
                                  key={index}
                                  className="px-3 py-2 bg-blue-100 text-blue-800 text-sm font-medium rounded-lg border border-blue-200"
                                  initial={{ opacity: 0, scale: 0.8 }}
                                  animate={{ opacity: 1, scale: 1 }}
                                  transition={{ duration: 0.2, delay: index * 0.1 }}
                                  whileHover={{ scale: 1.05 }}
                                >
                                  {skill}
                                </motion.span>
                              ))}
                            </div>
                          </motion.div>
                        )}

                        {/* Expérience professionnelle */}
                        <motion.div
                          className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.4, delay: 0.4 }}
                        >
                          <div className="flex items-center space-x-3 mb-6">
                            <div className="p-2 bg-orange-100 rounded-lg">
                              <Briefcase className="w-5 h-5 text-orange-600" />
                            </div>
                            <h3 className="text-xl font-semibold text-slate-900">Expérience</h3>
                          </div>
                          <div className="space-y-4">
                            <div>
                              <label className="text-sm font-medium text-slate-700">Niveau d'expérience</label>
                              <p className="text-lg text-slate-900 font-medium">
                                {formatExperience(candidate.experience)}
                              </p>
                            </div>
                            <div>
                              <label className="text-sm font-medium text-slate-700">Poste recherché</label>
                              <p className="text-slate-900">{candidate.jobTitle || 'Non spécifié'}</p>
                            </div>
                          </div>
                        </motion.div>
                      </div>

                      {/* Prétentions salariales */}
                      <motion.div
                        className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: 0.5 }}
                      >
                        <div className="flex items-center justify-between mb-6">
                          <div className="flex items-center space-x-3">
                            <div className="p-2 bg-emerald-100 rounded-lg">
                              <DollarSign className="w-5 h-5 text-emerald-600" />
                            </div>
                            <h3 className="text-xl font-semibold text-slate-900">Prétentions salariales</h3>
                          </div>
                          <motion.button
                            onClick={handleToggleSalary}
                            className="px-4 py-2 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition-colors duration-200"
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                          >
                            {showNet ? "Afficher Brut" : "Afficher Net"}
                          </motion.button>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                          <div className="text-center p-4 bg-slate-50 rounded-lg">
                            <p className="text-sm text-slate-600 mb-1">
                              Salaire annuel {showNet ? "net" : "brut"}
                            </p>
                            <p className="text-2xl font-bold text-slate-900">
                              {showNet
                                ? `${formatAmount(candidate.netYearlySalaryExpectations)} €`
                                : `${formatAmount(candidate.yearlySalaryExpectations)} €`}
                            </p>
                          </div>
                          <div className="text-center p-4 bg-slate-50 rounded-lg">
                            <p className="text-sm text-slate-600 mb-1">
                              Salaire mensuel {showNet ? "net" : "brut"}
                            </p>
                            <p className="text-2xl font-bold text-slate-900">
                              {showNet
                                ? `${formatAmount(candidate.netMonthlySalaryExpectations)} €`
                                : `${formatAmount(candidate.monthlySalaryExpectations)} €`}
                            </p>
                          </div>
                          <div className="text-center p-4 bg-slate-50 rounded-lg">
                            <p className="text-sm text-slate-600 mb-1">
                              Taux journalier {showNet ? "net" : "brut"}
                            </p>
                            <p className="text-2xl font-bold text-slate-900">
                              {showNet
                                ? `${formatAmount(candidate.netDailySalaryExpectations, 2)} €`
                                : `${formatAmount(candidate.dailySalaryExpectations, 2)} €`}
                            </p>
                          </div>
                        </div>
                      </motion.div>
                    </motion.div>
                  )}

                  {/* Onglet Documents */}
                  {activeTab === "documents" && (
                    <motion.div
                      key="documents"
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                      transition={{ duration: 0.3 }}
                    >
                      <DocumentSection candidate={candidate} />
                    </motion.div>
                  )}

                  {/* Onglet Disponibilité */}
                  {activeTab === "availability" && (
                    <motion.div
                      key="availability"
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                      transition={{ duration: 0.3 }}
                    >
                      <AvailableTable candidate={candidate} candidates={candidates} setCandidates={setCandidates} />
                    </motion.div>
                  )}

                  {/* Onglet Commentaires */}
                  {activeTab === "comments" && (
                    <motion.div
                      key="comments"
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                      transition={{ duration: 0.3 }}
                    >
                      <CandidateComment candidate={candidate} candidates={candidates} setCandidates={setCandidates} />
                    </motion.div>
                  )}

                  {/* Onglet Contrats */}
                  {activeTab === "contracts" && (
                    <motion.div
                      key="contracts"
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                      transition={{ duration: 0.3 }}
                    >
                      <CandidatContract candidate={candidate} />
                    </motion.div>
                  )}

                  {/* Onglet Entretiens */}
                  {activeTab === "interviews" && (
                    <motion.div
                      key="interviews"
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                      transition={{ duration: 0.3 }}
                    >
                      <InterviewsSection candidateId={candidate._id} />
                    </motion.div>
                  )}

                  {/* Onglet Opportunités */}
                  {activeTab === "opportunities" && (
                    <motion.div
                      key="opportunities"
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                      transition={{ duration: 0.3 }}
                    >
                      <OpportunitiesSection candidateId={candidate._id} />
                    </motion.div>
                  )}

                  {/* Onglet Paie */}
                  {activeTab === "payments" && (
                    <motion.div
                      key="payments"
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                      transition={{ duration: 0.3 }}
                    >
                      <PaymentsSection candidateId={candidate._id} />
                    </motion.div>
                  )}

                  {/* Onglet Notations */}
                  {activeTab === "ratings" && (
                    <motion.div
                      key="ratings"
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                      transition={{ duration: 0.3 }}
                    >
                      <RatingsSection candidateId={candidate._id} />
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </div>

            {/* Modals */}
            <AddDocumentModal
              isOpen={isAddDocumentModalOpen}
              onClose={() => setIsAddDocumentModalOpen(false)}
              onSubmit={(data) => {
                console.log("Document ajouté:", data);
                setIsAddDocumentModalOpen(false);
              }}
              candidateId={candidate._id}
            />

            <AddInterviewModal
              isOpen={isAddInterviewModalOpen}
              onClose={() => setIsAddInterviewModalOpen(false)}
              onSubmit={(data) => {
                console.log("Entretien ajouté:", data);
                setIsAddInterviewModalOpen(false);
              }}
              candidate={candidate}
            />

            <AddCommentModal
              isOpen={isAddCommentModalOpen}
              onClose={() => setIsAddCommentModalOpen(false)}
              onSubmit={(data) => {
                console.log("Commentaire ajouté:", data);
                setIsAddCommentModalOpen(false);
              }}
              candidateId={candidate._id}
            />

            <AddOpportunityModal
              isOpen={isAddOpportunityModalOpen}
              onClose={() => setIsAddOpportunityModalOpen(false)}
              onSubmit={(data) => {
                console.log("Opportunité ajoutée:", data);
                setIsAddOpportunityModalOpen(false);
              }}
              candidateId={candidate._id}
            />

            <AddContractModal
              isOpen={isAddContractModalOpen}
              onClose={() => setIsAddContractModalOpen(false)}
              onSubmit={(data) => {
                console.log("Contrat ajouté:", data);
                setIsAddContractModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <AddPayslipModal
              isOpen={isAddPayslipModalOpen}
              onClose={() => setIsAddPayslipModalOpen(false)}
              onSubmit={(data) => {
                console.log("Fiche de paie ajoutée:", data);
                setIsAddPayslipModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <ActivateCandidateModal
              isOpen={isActivateModalOpen}
              onClose={() => setIsActivateModalOpen(false)}
              onSubmit={(data) => {
                console.log("Candidat activé:", data);
                setIsActivateModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <AdvancePaymentModal
              isOpen={isAdvancePaymentModalOpen}
              onClose={() => setIsAdvancePaymentModalOpen(false)}
              onSubmit={(data) => {
                console.log("Acompte ajouté:", data);
                setIsAdvancePaymentModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <ReferenceCheckModal
              isOpen={isReferenceCheckModalOpen}
              onClose={() => setIsReferenceCheckModalOpen(false)}
              onSubmit={(data) => {
                console.log("Contrôle de référence:", data);
                setIsReferenceCheckModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <SendToFreelanceModal
              isOpen={isSendToFreelanceModalOpen}
              onClose={() => setIsSendToFreelanceModalOpen(false)}
              onSubmit={(data) => {
                console.log("Envoyé à freelance:", data);
                setIsSendToFreelanceModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <SickLeaveModal
              isOpen={isSickLeaveModalOpen}
              onClose={() => setIsSickLeaveModalOpen(false)}
              onSubmit={(data) => {
                console.log("Arrêt maladie ajouté:", data);
                setIsSickLeaveModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <AddAtdModal
              isOpen={isAddAtdModalOpen}
              onClose={() => setIsAddAtdModalOpen(false)}
              onSubmit={(data) => {
                console.log("ATD ajouté:", data);
                setIsAddAtdModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <PlacementContractModal
              isOpen={isPlacementContractModalOpen}
              onClose={() => setIsPlacementContractModalOpen(false)}
              onSubmit={(data) => {
                console.log("Contrat de placement:", data);
                setIsPlacementContractModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <EditProfileModal
              isOpen={isEditProfileModalOpen}
              onClose={() => setIsEditProfileModalOpen(false)}
              onSubmit={(data) => {
                console.log("Profil modifié:", data);
                setIsEditProfileModalOpen(false);
              }}
              candidate={candidate}
            />

            <AddRatingModal
              isOpen={isAddRatingModalOpen}
              onClose={() => setIsAddRatingModalOpen(false)}
              onSubmit={(data) => {
                console.log("Notation ajoutée:", data);
                setIsAddRatingModalOpen(false);
              }}
              candidateId={candidate.id}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};



 
